export default "__VITE_ASSET__CLqsoI8d__"